const Headings = {
  baseStyle: {
    fontWeight: 500,
  },
  variants: {
    standard: {
      color: "white",
      fontFamily: "heading",
      fontWeight: 500,
      m: 0,
    },
    standardSub: {
      fontFamily: "heading",
      fontWeight: 400,
      fontSize: "3xl",
    },
    standardMicro: {
      fontFamily: "heading",
      fontWeight: 400,
      fontSize: "xl",
    },
    base: {
      color: "black",
      size: ["sm", "md", "lg", "xl", "2xl", "3xl"],
    },
  },
}

export default Headings
